import * as React from "react";
import {useEffect, useLayoutEffect, useRef} from "react";
import {useLoader, useThree} from "@react-three/fiber";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {DRACOLoader} from "three/examples/jsm/loaders/DRACOLoader";
import {FBXLoader} from "three/examples/jsm/loaders/FBXLoader";
import {OBJLoader} from "three/examples/jsm/loaders/OBJLoader";

export interface ModelProps {
    url: string,
    ext: string,
    createNote: any,
    directCamera: any
}

function Model({url, ext, createNote, directCamera}: ModelProps) {
    const camera = useThree((state) => state.camera);
    const raycaster: any = useThree((state) => state.raycaster);
    const ref: any = useRef();

    let Loader: any;
    let extension: any;
    if (ext === 'gltf' || ext === 'glb') {
        Loader = GLTFLoader;
        extension = (gltfLoader: GLTFLoader) => {
            const dracoLoader = new DRACOLoader();
            dracoLoader.setDecoderPath('../draco/');
            gltfLoader.setDRACOLoader(dracoLoader);
        }
    } else if (ext === 'fbx') {
        Loader = FBXLoader;
    } else {
        Loader = OBJLoader;
    }

    const geometry: any = useLoader(Loader, url, extension);
    const model = geometry.scene ? geometry.scene : geometry;

    useEffect(() => {
        if (model) {
            model.traverse((node: any) => {
                if (node.isMesh) {
                    node.castShadow = true;
                    node.receiveShadow = true;
                }
            });
        }
    }, [model]);

    useLayoutEffect(() => ref && directCamera(ref.current), [directCamera]);

    return (
        <mesh ref={ref} rotation={ext === 'fbx'?[-Math.PI / 2, 0, 0]: [0,0,0]} position={[0, 0, 0]}>
            <primitive object={model}
                       onDoubleClick={(e: any) => {
                           createNote(e, camera, raycaster);
                       }}
            />
        </mesh>

    )
}

export default Model;
